export default __webpack_public_path__ + "static/media/tradition.23907665.webp";